import React from "react";
import LandingTemplate from "@/components/LandingTemplate";
import usePageMeta from "@/lib/usePageMeta";

export default function DesignAestetik() {
  usePageMeta({
    title: "Design & æstetik — Døre og vinduer der løfter facaden",
    description:
      "Slanke rammer, gennemtænkte proportioner og materialer, der spiller sammen med husets arkitektur. Book rådgivning hos Hagelund.",
    path: "/lp/design-aestetik",
  });

  return (
    <LandingTemplate
      testId="landing-design"
      page="Design/æstetik"
      eyebrow="Design & æstetik"
      titleLines={["Døre og vinduer", "der løfter", "facaden"]}
      valueProp="Slanke rammer, gennemtænkte proportioner og materialer, der spiller sammen med husets arkitektur. Vi designer løsninger, der bare passer."
      points={[
        "Skræddersyet til husets stil og periode",
        "Maksimalt lysindfald med slanke rammer",
        "Materialer, greb og finish valgt med omhu",
        "Et roligt, tidløst og eksklusivt udtryk",
      ]}
      image="/images/skovvej-11.webp"
      gallery={["/images/skovvej-6.webp", "/images/christiansminde-19.webp", "/images/skovvej-5.webp"]}
    />
  );
}
